import React from 'react'
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'

const LinkToText = ({contentItemPath}) => {
  if(contentItemPath !== null && contentItemPath.length > 0){
    return ( 
      <p className="mb-5"><a href={contentItemPath}><FontAwesomeIcon icon={faFileAlt}/> View/download the text-only version</a></p>
  ) 
  } else {
      return null
    }
}

export default LinkToText;